import styled from 'styled-components';
import { theme } from '../theme';

export const BlockedUsersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.sm};
`;

export const BlockedUserItem = styled.div`
  display: flex;
  align-items: center;
  padding: ${theme.spacing.md};
  background: ${theme.colors.background.card};
  border-radius: ${theme.borderRadius.md};
  border: 1px solid ${theme.colors.border.light};
  transition: all ${theme.transitions.normal};
  
  &:hover {
    border-color: ${theme.colors.border.medium};
    box-shadow: ${theme.shadows.light};
  }
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.spacing.sm};
  }
`;

export const BlockedUserAvatar = styled.div<{ $photo?: string }>`
  width: 60px;
  height: 60px;
  border-radius: ${theme.borderRadius.full};
  background: ${props => props.$photo 
    ? `url(${props.$photo}) center/cover` 
    : theme.colors.gradients.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.text.light};
  font-weight: 600;
  font-size: 1.25rem;
  flex-shrink: 0;
  margin-right: ${theme.spacing.md};
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    margin-right: 0;
    margin-bottom: ${theme.spacing.xs};
  }
`;

export const BlockedUserInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const BlockedUserName = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: ${theme.colors.text.primary};
  margin-bottom: ${theme.spacing.xs};
`;

export const BlockedUserDetails = styled.div`
  font-size: 0.875rem;
  color: ${theme.colors.text.secondary};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
`;

export const BlockedUserActions = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    width: 100%;
    justify-content: flex-end;
  }
`;

export const UnblockButton = styled.button`
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  background: ${theme.colors.primary};
  color: ${theme.colors.text.light};
  border: none;
  border-radius: ${theme.borderRadius.md};
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all ${theme.transitions.normal};
  
  &:hover {
    background: ${theme.colors.hover.primary};
    transform: translateY(-1px);
    box-shadow: ${theme.shadows.medium};
  }
  
  &:active {
    transform: translateY(0);
  }
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    flex: 1;
  }
`;

export const EmptyBlockedUsersState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing.xl};
  text-align: center;
  background: ${theme.colors.background.card};
  border-radius: ${theme.borderRadius.lg};
  box-shadow: ${theme.shadows.light};
`;






